// import Swiper bundle with all modules installed
import Swiper from 'swiper/bundle';
import 'swiper/css/bundle';

const sliderActivities = () => {
  let swiperInstances = [];

  const initializeSliders = () => {
    const slidersWrapper = document.querySelectorAll('.activities__slider');
    if (slidersWrapper.length > 0) {
      slidersWrapper.forEach(slider => {
        const parentWrapper = slider.closest('.activities__slider-wrapper');
        const isMobileSlider = parentWrapper.classList.contains('mobile');
        const isDesktopSlider = parentWrapper.classList.contains('desktop');

        // Initialize Swiper only if conditions match the current viewport width
        if (window.innerWidth >= 768 && isDesktopSlider) {
          const swiper = new Swiper(slider, {
            slidesPerView: 1,
            spaceBetween: 30,
            autoHeight: true,
            loop: true,
            freeMode: false,
            navigation: {
              nextEl: parentWrapper.querySelector('.activities__slider-btn--next'),
              prevEl: parentWrapper.querySelector('.activities__slider-btn--prev'),
            },
            breakpoints: {
              768: {
                autoHeight: false,
              },
            },
          });
          swiperInstances.push(swiper); // Save the instance
        } else if (window.innerWidth < 768 && isMobileSlider) {
          const swiper = new Swiper(slider, {
            slidesPerView: 1,
            spaceBetween: 30,
            autoHeight: true,
            loop: true,
            freeMode: false,
            navigation: {
              nextEl: parentWrapper.querySelector('.activities__slider-btn--next'),
              prevEl: parentWrapper.querySelector('.activities__slider-btn--prev'),
            },
          });
          swiperInstances.push(swiper); // Save the instance
        }
      });
    }
  };

  const destroySliders = () => {
    swiperInstances.forEach(swiper => swiper.destroy(true, true));
    swiperInstances = []; // Clear the array after destruction
  };

  const checkWindowSize = () => {
    destroySliders(); // Destroy existing sliders before reinitializing
    initializeSliders(); // Reinitialize based on current window size
  };

  // Initialize sliders on page load
  checkWindowSize();

  // Add event listener for window resize
  window.addEventListener('resize', () => {
    checkWindowSize();
  });
};

export default sliderActivities;
